export default "__VITE_ASSET__ce4a81fb__"